import { IPagination } from 'app/types/common';

export interface IBulkImportsState {
  readonly bulkImportsById?: any;
  readonly bulkImportIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectBulkImportLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddBulkImport?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationBulkImportIds?: string[];
  readonly currentBulkImportId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IBulkImportsSelector extends IBulkImportsState {
  readonly currentBulkImport?: any;
  readonly currentFormBulkImport?: any;
  readonly bulkImportsFilteredByTagInSelectFormat?: any;
  readonly bulkImportsByIdInSelectFormat?: any;
  readonly bulkImportsFilteredByOrganisationInSelectFormat?: any;
}

export enum BulkImportsActionTypes {
  GET_ALL_BULK_IMPORTS_REQUESTED = 'redux-app/bulk-imports/GET_ALL_BULK_IMPORTS_REQUESTED',
  GET_ALL_BULK_IMPORTS_PENDING = 'redux-app/bulk-imports/GET_ALL_BULK_IMPORTS_PENDING',
  GET_ALL_BULK_IMPORTS_SUCCESS = 'redux-app/bulk-imports/GET_ALL_BULK_IMPORTS_SUCCESS',
  GET_ALL_BULK_IMPORTS_FAIL = 'redux-app/bulk-imports/GET_ALL_BULK_IMPORTS_FAIL',
  GET_BULK_IMPORT_REQUESTED = 'redux-app/bulk-imports/GET_BULK_IMPORT_REQUESTED',
  GET_BULK_IMPORT_PENDING = 'redux-app/bulk-imports/GET_BULK_IMPORT_PENDING',
  GET_BULK_IMPORT_SUCCESS = 'redux-app/bulk-imports/GET_BULK_IMPORT_SUCCESS',
  GET_BULK_IMPORT_FAIL = 'redux-app/bulk-imports/GET_BULK_IMPORT_FAIL',
  UPDATE_BULK_IMPORT_REQUESTED = 'redux-app/bulk-imports/UPDATE_BULK_IMPORT_REQUESTED',
  UPDATE_BULK_IMPORT_PENDING = 'redux-app/bulk-imports/UPDATE_BULK_IMPORT_PENDING',
  UPDATE_BULK_IMPORT_SUCCESS = 'redux-app/bulk-imports/UPDATE_BULK_IMPORT_SUCCESS',
  UPDATE_BULK_IMPORT_FAIL = 'redux-app/bulk-imports/UPDATE_BULK_IMPORT_FAIL',
  CREATE_BULK_IMPORT_REQUESTED = 'redux-app/bulk-imports/CREATE_BULK_IMPORT_REQUESTED',
  CREATE_BULK_IMPORT_PENDING = 'redux-app/bulk-imports/CREATE_BULK_IMPORT_PENDING',
  CREATE_BULK_IMPORT_SUCCESS = 'redux-app/bulk-imports/CREATE_BULK_IMPORT_SUCCESS',
  CREATE_BULK_IMPORT_FAIL = 'redux-app/bulk-imports/CREATE_BULK_IMPORT_FAIL',
  DELETE_BULK_IMPORT_REQUESTED = 'redux-app/bulk-imports/DELETE_BULK_IMPORT_REQUESTED',
  DELETE_BULK_IMPORT_PENDING = 'redux-app/bulk-imports/DELETE_BULK_IMPORT_PENDING',
  DELETE_BULK_IMPORT_SUCCESS = 'redux-app/bulk-imports/DELETE_BULK_IMPORT_SUCCESS',
  DELETE_BULK_IMPORT_FAIL = 'redux-app/bulk-imports/DELETE_BULK_IMPORT_FAIL',
  SELECT_BULK_IMPORT_REQUESTED = 'redux-app/bulk-imports/SELECT_BULK_IMPORT_REQUESTED',
}

export default null;
